import BulkItemUploadModalSuspense from '../src/BulkItemUploadModalSuspense.tsx';
export default BulkItemUploadModalSuspense;
